import React, { Component } from 'react';

class Banner extends Component {
  state = {
    visible: false,
    data: "",
  };

  componentDidMount() {
    this.handleLoad();
  }
  
  handleLoad = async () => {
    try {
      const response = await fetch(`/api/banner/load`, { method: 'GET'});

      if (response.ok) {
        const data = await response.text();
        if (data.startsWith('data:image/png;base64,')) {
          this.setState({ data: data, visible: true });
        }
      }
    } catch (error) {  }
  };

  handleClose = () => {
    this.setState({ visible: false });
  };

  renderStyles = () => (
    <style>
      {`
        .banner {
          top: 100px;
          right: 100px;
          color: white;
          width: 450px;
          height: 450px;
          padding: 15px 0;
          z-index: 9999;
          position: fixed;
          text-align: center;
        }

        .banner img.main {
          width: 450px;
          height: 450px;
          position: relative;
        }

        .banner img.close {
          top: 20px;
          right: 20px;
          color: white;
          cursor: pointer;
          position: absolute;
          width: 30px;
          height: 30px;
        }
      `}
    </style>
  );

  render() {
    if (!this.state.visible) {
      return null;
    }

    return (
      <>
        {this.renderStyles()}
        <div className="banner">
          <img
            className="main"
            src={this.state.data}
            alt="баннер"
          />
          <img
            className="close"
            src="./images/icons/close.svg"
            alt="close"
            onClick={this.handleClose}
          />
        </div>
      </>
    );
  }
}

export default Banner;
